// mc-delivery.js, the postcode delivery checker (audit-2026-09-18, metro rule 2026-09-26).
// Wires every [data-mc-delivery] block on the page (the product page buy box and the cart assurance section).
// Delivery is only promised free to metro postcodes; every other postcode is asked to contact the team.
// The metro list is window.MC_ZONES from assets/mc-delivery-zones.js (built by build-zones.mjs), which must run
// first. The phone number and delivery window come from window.MC_FACTS (assets/mc-facts.js) when present.
(function () {
  'use strict';

  var STORAGE_KEY = 'mc_postcode';
  var EMAIL = 'info@mattresscrafters.com.au';

  function readStoredPostcode() {
    try { return window.localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }
  function storePostcode(pc) {
    try { window.localStorage.setItem(STORAGE_KEY, pc); } catch (e) { /* private window or blocked storage, ignore */ }
  }

  function facts() { return window.MC_FACTS || {}; }
  function phone() { return facts().phone || '0408 106 552'; }
  function phoneHref() { return facts().phoneHref || 'tel:+61408106552'; }
  function deliveryWindow() { return facts().deliveryWindow || '2 to 12'; }

  function place(zone, postcode) {
    return '<b>' + (zone && zone[0] ? zone[0] + ' ' : '') + postcode + '</b>';
  }

  function resultMarkup(postcode) {
    var zone = window.MC_ZONES && window.MC_ZONES[postcode];
    var where = place(zone, postcode);
    if (zone && zone[1] === 'free-nextday') {
      return 'Free delivery to ' + where + ', and most Melbourne metro orders arrive the next business day.';
    }
    if (zone && zone[1] === 'free') {
      return 'Free delivery to ' + where + ', usually ' + deliveryWindow() + ' business days from dispatch.';
    }
    return where + ' is outside the metro areas we deliver free to, so contact the team on <a href="' + phoneHref() + '" style="white-space:nowrap">' + phone() +
      '</a> or <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> and we will work out delivery to you.';
  }

  function showResult(block, html, state) {
    var result = block.querySelector('[data-mc-result]');
    if (!result) return;
    result.innerHTML = html;
    result.hidden = false;
    if (state) result.setAttribute('data-state', state); else result.removeAttribute('data-state');
  }

  function check(block) {
    var input = block.querySelector('[data-mc-postcode]');
    if (!input) return;
    var postcode = (input.value || '').trim();
    if (!/^\d{4}$/.test(postcode)) {
      showResult(block, 'Enter a 4 digit postcode.', 'error');
      return;
    }
    storePostcode(postcode);
    // keep every instance on the page in sync
    document.querySelectorAll('[data-mc-postcode]').forEach(function (i) { i.value = postcode; });
    showResult(block, resultMarkup(postcode));
  }

  function wire(block) {
    if (block.getAttribute('data-mc-wired')) return;
    block.setAttribute('data-mc-wired', '1');
    var input = block.querySelector('[data-mc-postcode]');
    var btn = block.querySelector('[data-mc-check]');
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 4);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(block); }
      });
      var stored = readStoredPostcode();
      if (stored) input.value = stored;
    }
    if (btn) btn.addEventListener('click', function () { check(block); });
  }

  function wireAll() {
    var blocks = document.querySelectorAll('[data-mc-delivery]');
    for (var i = 0; i < blocks.length; i++) wire(blocks[i]);
  }

  function init() {
    wireAll();
    var app = document.getElementById('app');
    if (app && window.MutationObserver) {
      var mo = new MutationObserver(wireAll);
      mo.observe(app, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
